/* PUFF storefront controller (site B). A framework-free port of the Component in design/PUFF Site.dc.html.
   It owns view state (home / product), the scroll story, the aura and size pickers, the Shopify cart, the menu,
   the info overlay and the popup timer. The <puff-sky> and <puff-model> elements come from puff-engine.js. */
(function () {
  'use strict';

  const AURAS = [
    { id: 'red', name: 'Red', hex: '#E4002B', m: 'PASSION, POWER & FIRE' },
    { id: 'orange', name: 'Orange', hex: '#FF8200', m: 'ENERGY, CREATIVITY & DESIRE' },
    { id: 'yellow', name: 'Yellow', hex: '#FEDD00', m: 'CONFIDENCE, RADIANCE & JOY' },
    { id: 'green', name: 'Green', hex: '#78BE20', m: 'GROWTH, BALANCE & HEALING' },
    { id: 'sky-blue', name: 'Sky Blue', hex: '#3ED5FF', m: 'CALMNESS, WISDOM & HONESTY' },
    { id: 'blue', name: 'Blue', hex: '#005EB8', m: 'INTUITION, MYSTERY & DEPTH' },
    { id: 'purple', name: 'Purple', hex: '#9063CD', m: 'SPIRITUALITY, DEDICATION & INFLUENCE' }
  ];
  const SKY = 4;
  const PHOTO = ['Aura', 'Front', 'Chest print', 'Sleeve stitching', 'Shoulder', 'Back print'];
  const OTHER = ['Aura', 'Front', 'Chest print', 'Sleeve', 'Shoulder', 'Back'];
  const STORY_STOP = [0, 0, 7, 1]; // model picture shown behind each scroll-story chapter
  const DESK_MQ = '(min-width: 900px) and (min-aspect-ratio: 1/1)';
  const reduceMotion = () => window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const norm = (v) => String(v || '').toLowerCase().replace(/[^a-z]/g, '');
  const onColor = (hex) => { const v = parseInt(hex.slice(1), 16); return (0.299 * (v >> 16) + 0.587 * (v >> 8 & 255) + 0.114 * (v & 255)) > 150 ? '#0D1734' : '#ffffff'; };
  const stopsFor = (a) => { const id = AURAS[a].id; return id === 'sky-blue' ? PHOTO : (id === 'yellow' || id === 'green') ? OTHER.filter(l => l !== 'Shoulder') : OTHER; };

  function formatMoney(cents, format) {
    const fmt = format || '£{{amount}}';
    const n = (Number(cents) || 0) / 100;
    const group = (x, dec, th, ds) => { const [i, f] = x.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? ds + f : ''); };
    const out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return group(n, 2, "'", '.');
      return group(n, 2, ',', '.');
    });
    return out.replace(/([.,])00(?!\d)/, '').replace(/<[^>]*>/g, '');
  }

  class PuffSite {
    constructor(root, cfg) {
      this.root = root; this.cfg = cfg || {};
      this.product = this.cfg.product || null;
      this.money = this.cfg.moneyFormat;
      this.s = { view: 'home', aura: SKY, stop: 0, dir: 1, size: null, needSize: false, menu: false, info: false, bagOpen: false, story: -1, scrolled: false, awC: SKY, cyc: 0, cycS: 0, book: 0 };
      this.cart = { items: [], item_count: 0, total_price: 0 };
      this.lastNav = 0;
      this.mapOptions();
      this.initialView();
      this.cacheEls();
      this.bind();
      this.buildStatic();
      this.setLayout();
      this.render();
      this.anims();
      this.layout();
      this.onScroll();
      setTimeout(this.layout, 400); setTimeout(this.layout, 1200);
      document.fonts && document.fonts.ready.then(() => this.layout());
      this.loadCart();
      this.startTimers();
      this.startView();
    }

    /* ---------- elements ---------- */
    $(name) { return this.root.querySelector('[data-el="' + name + '"]'); }
    $$(name) { return Array.from(this.root.querySelectorAll('[data-el="' + name + '"]')); }
    cacheEls() {
      const n = ['sky', 'scroll', 'story', 'modelWrap', 'model', 'pulse', 'awText', 'det0', 'det1', 'det2', 'tilt', 'puffImg', 'shine', 'puffTitle', 'cap1', 'cap2', 'fitWrap', 'fitCap', 'stitchWrap', 'stitchLine', 'stitchRect', 'chip0', 'chip1', 'chip2', 'book', 'bookLabel', 'orbit', 'orbitQ', 'tally', 'gesture', 'auraUpper', 'slim', 'sizeBox', 'swatches', 'arrowPrev', 'arrowNext', 'shipbar', 'bag', 'bagTitle', 'bagEmpty', 'bagItems', 'bagFoot', 'shipMeter', 'shipNote', 'subtotal', 'toast', 'slotBack', 'slotZoom', 'slot', 'info', 'infoScroll', 'infoSky', 'menu', 'menuSky', 'swipeBob'];
      this.e = {}; n.forEach(k => { this.e[k] = this.$(k); });
      this.tapBtn = this.root.querySelector('.puff-model-tap');
      this.sizeBtns = Array.from(this.root.querySelectorAll('[data-size]'));
    }

    /* ---------- product options ---------- */
    mapOptions() {
      const p = this.product; this.auraOpt = -1; this.sizeOpt = -1;
      if (!p) return;
      (p.options || []).forEach((name, i) => {
        if (/aura|colou?r/i.test(name)) this.auraOpt = i;
        else if (/size/i.test(name)) this.sizeOpt = i;
      });
      // Fall back to the option values, whatever the options are called.
      (p.options || []).forEach((_, i) => {
        const vals = p.variants.map(v => norm(v.options[i]));
        if (this.auraOpt < 0 && vals.every(x => AURAS.some(a => norm(a.name) === x))) this.auraOpt = i;
        else if (this.sizeOpt < 0 && i !== this.auraOpt && vals.every(x => /^(x{0,3}s|m|x{0,3}l|\d?xl)$/.test(x))) this.sizeOpt = i;
      });
    }
    auraOfVariant(v) { if (!v || this.auraOpt < 0) return -1; const k = norm(v.options[this.auraOpt]); return AURAS.findIndex(a => norm(a.name) === k || norm(a.id) === k); }
    variantFor(a, size) {
      const p = this.product; if (!p) return null;
      return p.variants.find(v => (this.auraOpt < 0 || this.auraOfVariant(v) === a) && (this.sizeOpt < 0 || !size || v.options[this.sizeOpt] === size)) || null;
    }

    /* ---------- events ---------- */
    bind() {
      const A = {
        tapModel: () => this.openProduct(SKY),
        goAura: () => this.scrollToSel('#aura'),
        puffTap: () => this.puffTap(),
        up: () => this.shift(1), down: () => this.shift(-1),
        prev: () => this.turn(-1), next: () => this.turn(1),
        addToBag: () => this.addToBag(),
        menuBtn: () => this.menuBtn(),
        bagBtn: () => this.set({ menu: false, bagOpen: !this.s.bagOpen }),
        closeBag: () => this.set({ bagOpen: false }),
        closeInfo: () => this.set({ info: false }),
        navShop: () => this.navShop(), navAura: () => this.navTo('#aura'), navFam: () => this.navTo('#familia'),
        sizeGuide: () => { if (this.s.view === 'product') this.goHome(); this.navTo('#size-guide'); },
        bookPrev: () => this.bookGo(-1), bookNext: () => this.bookGo(1),
        logo: () => { if (this.s.info) this.set({ info: false }); else if (this.s.view === 'product') this.goHome(); else this.e.scroll && this.e.scroll.scrollTo({ top: 0, behavior: 'smooth' }); }
      };
      this.root.addEventListener('click', (ev) => {
        const sz = ev.target.closest('[data-size]');
        if (sz && this.root.contains(sz)) { this.set({ size: sz.dataset.size, needSize: false }); return; }
        const sw = ev.target.closest('[data-aura-pick]');
        if (sw) { this.pickAura(+sw.dataset.auraPick); return; }
        const inf = ev.target.closest('[data-info]');
        if (inf && this.root.contains(inf)) { ev.preventDefault(); this.openInfo(inf.dataset.info); return; }
        const act = ev.target.closest('[data-action]');
        if (act && this.root.contains(act) && A[act.dataset.action]) {
          if (act.tagName === 'A') ev.preventDefault();
          A[act.dataset.action](ev);
        }
      });
      if (this.e.scroll) this.e.scroll.addEventListener('scroll', this.onScroll, { passive: true });
      const g = this.e.gesture;
      if (g) {
        g.addEventListener('pointerdown', (e) => { this.p0 = { x: e.clientX, y: e.clientY }; });
        g.addEventListener('pointerup', (e) => {
          const p = this.p0; this.p0 = null; if (!p || this.s.view !== 'product') return;
          const dx = e.clientX - p.x, dy = e.clientY - p.y; if (Math.max(Math.abs(dx), Math.abs(dy)) < 28) return;
          if (Math.abs(dx) > Math.abs(dy)) this.turn(dx < 0 ? 1 : -1); else this.shift(dy < 0 ? 1 : -1);
        });
        g.addEventListener('wheel', (e) => {
          if (this.s.view !== 'product') return; const ax = Math.abs(e.deltaX), ay = Math.abs(e.deltaY); if (Math.max(ax, ay) < 6) return;
          e.preventDefault(); if (ax > ay) this.turn(e.deltaX > 0 ? 1 : -1); else this.shift(e.deltaY > 0 ? 1 : -1);
        }, { passive: false });
      }
      this.root.addEventListener('keydown', (e) => this.onKey(e));
      document.addEventListener('keydown', (e) => { if (e.target === document.body) this.onKey(e); });
      const d0 = this.e.det0;
      if (d0) { d0.addEventListener('pointermove', (e) => this.tilt(e)); d0.addEventListener('pointerleave', () => this.untilt()); }
      const tabs = this.$('infoTabs');
      if (tabs) {
        const edge = () => { const max = tabs.scrollWidth - tabs.clientWidth, x = tabs.scrollLeft; tabs.classList.toggle('is-fits', max <= 2); tabs.classList.toggle('is-end', max > 2 && x >= max - 2); tabs.classList.toggle('is-mid', x > 2 && x < max - 2); };
        tabs.addEventListener('scroll', edge, { passive: true }); window.addEventListener('resize', edge); setTimeout(edge, 300); document.fonts && document.fonts.ready.then(edge);
      }
      if (this.e.book) this.e.book.addEventListener('scroll', () => { const el = this.e.book, pg = Math.round(el.scrollLeft / Math.max(1, el.clientWidth)); if (pg !== this.s.book) this.set({ book: pg }); }, { passive: true });
      if (this.e.slotBack) {
        this.e.slotBack.addEventListener('click', (e) => { if (e.target === this.e.slotBack || e.target === this.e.slotZoom) this.closeSlot(); });
        this.root.addEventListener('puff-slot-close', () => this.closeSlot());
      }
      this.mq = window.matchMedia(DESK_MQ);
      const re = () => { this.setLayout(); this.layout(); this.slotZoom(); };
      this.mq.addEventListener ? this.mq.addEventListener('change', re) : this.mq.addListener(re);
      if (window.ResizeObserver) { this.ro = new ResizeObserver(() => { this.layout(); this.slotZoom(); }); this.ro.observe(this.root); }
      window.addEventListener('popstate', () => this.fromLocation());
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.loadCart(); });
    }

    buildStatic() {
      const sw = this.e.swatches;
      if (sw) sw.innerHTML = AURAS.map((a, i) => '<button class="puff-swatch" type="button" data-aura-pick="' + i + '" aria-label="' + a.name + '" title="' + a.name + '" style="background:' + a.hex + '"></button>').join('');
      const ob = this.e.orbit;
      if (ob) ob.innerHTML = AURAS.map((a, i) => { const t = (i / 7) * Math.PI * 2 - Math.PI / 2; return '<div class="puff-orbit__dot" style="left:' + (50 + Math.cos(t) * 40).toFixed(2) + '%; top:' + (50 + Math.sin(t) * 40).toFixed(2) + '%; background:' + a.hex + ';"></div>'; }).join('');
      if (this.e.tally) this.e.tally.href = this.cfg.tallyUrl || '#';
    }

    setLayout() {
      const desk = window.matchMedia(DESK_MQ).matches;
      this.desk = desk; this.root.dataset.layout = desk ? 'desk' : 'phone';
      const o = desk ? 'landscape' : 'portrait';
      [this.e.sky, this.e.infoSky, this.e.menuSky].forEach(sk => { if (sk && sk.getAttribute('orientation') !== o) sk.setAttribute('orientation', o); });
      if (this.e.sky) this.e.sky.setAttribute('origin', desk ? '0.5,0.5' : '0.5,0.46');
    }

    /* ---------- state ---------- */
    set(patch) {
      const prevStory = this.s.story;
      Object.assign(this.s, patch);
      this.render();
      if ('story' in patch && patch.story !== prevStory) this.storyChanged(prevStory, this.s.story);
    }
    locked(ms) { const n = performance.now(); if (n - this.lastNav < ms) return true; this.lastNav = n; return false; }
    stageStop() { const s = this.s; if (s.view === 'product') return s.stop; if (s.story >= 0) return STORY_STOP[s.story]; return 0; }

    render() {
      const s = this.s, r = this.root, desk = this.desk, prod = s.view === 'product';
      const aIdx = prod ? s.aura : SKY, a = AURAS[aIdx], stop = this.stageStop(), n = stopsFor(aIdx).length;
      r.dataset.view = s.view; r.dataset.story = String(s.story);
      r.classList.toggle('is-menu', !!s.menu); r.classList.toggle('is-bag', !!s.bagOpen); r.classList.toggle('is-back', prod || !!s.info);
      r.classList.toggle('is-need-size', !!s.needSize); r.classList.toggle('has-bag', this.cart.item_count > 0);
      r.style.setProperty('--aura-hex', a.hex); r.style.setProperty('--on-aura', onColor(a.hex));

      const sky = this.e.sky; if (sky && sky.getAttribute('aura') !== a.id) sky.setAttribute('aura', a.id);
      const m = this.e.model;
      if (m) {
        const st = String(prod && a.id === 'sky-blue' && stop > 0 ? stop + 10 : stop);
        if (m.getAttribute('aura') !== a.id) m.setAttribute('aura', a.id);
        if (m.getAttribute('stop') !== st) m.setAttribute('stop', st);
        m.setAttribute('dir', String(s.dir));
      }

      let tf;
      if (prod) tf = desk ? 'translate3d(0,0,0) scale(.94)' : 'translate3d(0,-5cqh,0) scale(1)';
      else if (s.story === 0 || s.story < 0) tf = desk ? 'translate3d(0,0,0) scale(.9)' : 'translate3d(0,0,0) scale(.78)';
      else if (s.story < 3) tf = desk ? 'translate3d(-15cqw,8cqh,0) scale(.86)' : 'translate3d(0,10cqh,0) scale(.74)';
      else tf = desk ? 'translate3d(-15cqw, calc((1 - var(--rise)) * 55cqh), 0) scale(.86)' : 'translate3d(0, calc((1 - var(--rise)) * 55cqh), 0) scale(.76)';
      const mw = this.e.modelWrap;
      if (mw) {
        mw.style.transition = !prod && s.story === 3 ? 'opacity .15s ease' : (!prod && s.story >= 0 && s.story < 3 ? 'transform .5s ease, opacity .25s ease' : 'transform .75s cubic-bezier(.2,.8,.2,1), opacity .45s ease');
        mw.style.transform = tf;
        mw.style.translate = prod ? '0px 0px' : '0px calc(var(--drop) * 110cqh)';
        mw.style.opacity = !prod && s.story >= 1 && s.story < 3 ? '0' : '1';
      }
      if (this.tapBtn) this.tapBtn.style.pointerEvents = prod || (s.story >= 0 && s.story < 3) ? 'none' : 'auto';

      const txt = (k, v) => this.$$(k).forEach(el => { if (el.textContent !== v) el.textContent = v; });
      txt('auraUpper', a.name.toUpperCase()); txt('auraName', a.name);
      txt('sizeHint', s.needSize ? 'Pick a size first' : (s.size ? 'Size ' + s.size : 'Pick a size'));
      const v = this.variantFor(aIdx, s.size) || this.variantFor(aIdx, null);
      if (v) txt('price', formatMoney(v.price, this.money));
      this.sizeBtns.forEach(b => {
        b.classList.toggle('is-on', b.dataset.size === s.size);
        const sv = this.product && this.sizeOpt >= 0 ? this.variantFor(aIdx, b.dataset.size) : null;
        b.classList.toggle('is-out', !!(this.product && this.sizeOpt >= 0 && (!sv || !sv.available)));
      });
      this.root.querySelectorAll('[data-aura-pick]').forEach(b => b.classList.toggle('is-on', +b.dataset.auraPick === aIdx));
      [this.e.arrowPrev, this.e.arrowNext].forEach(b => { if (b) b.style.opacity = n > 1 ? '1' : '.35'; });

      if (this.e.awText) this.e.awText.style.color = AURAS[s.awC].hex;
      const ca = AURAS[s.cyc % 7], words = ca.m.split(/, | & /);
      ['chip0', 'chip1', 'chip2'].forEach((k, i) => { const c = this.e[k]; if (c) { c.textContent = words[i]; c.style.color = ca.hex; } });
      if (this.e.stitchLine) this.e.stitchLine.setAttribute('stroke', AURAS[s.cycS % 7].hex);

      if (this.e.bookLabel) this.e.bookLabel.textContent = (s.book + 1) + ' / 3';
      r.querySelectorAll('[data-action="bookPrev"]').forEach(b => { b.style.opacity = s.book > 0 ? '1' : '.35'; });
      r.querySelectorAll('[data-action="bookNext"]').forEach(b => { b.style.opacity = s.book < 2 ? '1' : '.35'; });

      if (this.e.info) { this.e.info.classList.toggle('is-open', !!s.info || this.cfg.startView === 'info'); this.e.info.setAttribute('aria-hidden', s.info ? 'false' : 'true'); }
      if (this.e.menu) this.e.menu.setAttribute('aria-hidden', s.menu ? 'false' : 'true');
      if (this.e.bag) this.e.bag.setAttribute('aria-hidden', s.bagOpen ? 'false' : 'true');
      r.querySelectorAll('[data-action="menuBtn"]').forEach(b => b.setAttribute('aria-label', s.info || prod ? 'Back' : 'Menu'));
    }

    /* ---------- scroll story ---------- */
    layout = () => {
      const sc = this.e.scroll, w = this.e.cap2, d = this.e.det2, f = this.e.fitCap; if (!sc || !w || !d || !f) return;
      const H = sc.clientHeight || 1, s0 = 1.4 * H;
      const ya = Math.max(w.offsetTop + w.offsetHeight - (d.offsetTop + d.offsetHeight), s0 + 1.9 * H), R = 0.55 * H;
      const fitTop = ya + R + 0.85 * H, yd = fitTop - (this.desk ? 150 : 168) + 0.5 * H;
      this.L = { ya, R };
      const storyH = Math.round(yd + H) + 'px', top = Math.round(fitTop) + 'px', h = Math.round(0.5 * H + f.offsetHeight) + 'px';
      if (this.e.story.style.height !== storyH) this.e.story.style.height = storyH;
      const fw = this.e.fitWrap; if (fw && (fw.style.top !== top || fw.style.height !== h)) { fw.style.top = top; fw.style.height = h; }
      this.onScroll();
    };

    onScroll = () => {
      if (this._sr) return;
      this._sr = requestAnimationFrame(() => {
        this._sr = 0;
        const sc = this.e.scroll, root = this.root; if (!sc) return;
        const H = sc.clientHeight || 1, y = sc.scrollTop, s0 = H * 1.4;
        root.style.setProperty('--hero', Math.min(1, y / (H * 0.45)).toFixed(3));
        { const d = Math.max(0, Math.min(1, (y - H * 0.22) / (H * 0.6))); root.style.setProperty('--drop', (y >= (this.L ? this.L.ya : s0 + 2.5 * H) ? 0 : d * d).toFixed(4)); }
        let story = -1;
        for (let k = 0; k < 3; k++) { const p = (y - (s0 + k * H)) / H; root.style.setProperty('--p' + k, Math.max(0, Math.min(1, p + 0.5)).toFixed(3)); if (p >= -0.5 && p < 0.5) story = k; }
        if (story < 0 && y >= H * 0.5) story = 0;
        if (y >= s0 + 2.5 * H) story = 2;
        const L = this.L || { ya: s0 + 2.5 * H, R: 0.7 * H };
        if (y >= L.ya) story = 3;
        root.style.setProperty('--rise', Math.max(0, Math.min(1, (y - L.ya) / L.R)).toFixed(4));
        const topOf = (n) => { let v = 0; while (n && n !== sc) { v += n.offsetTop; n = n.offsetParent; } return v - y; };
        const vis = (el) => { el = el && (el.firstElementChild || el); if (!el) return 0; const top = topOf(el), a = H - Math.min(el.offsetHeight, H) * 0.35; return (a - top) / Math.max(1, a); };
        const sF = vis(this.e.cap1);
        const swr = this.e.stitchWrap; if (swr && swr.parentNode) { const fw = Math.max(0, Math.min(1, sF)), full = swr.parentNode.clientWidth; swr.style.width = (fw >= 1 ? full : Math.floor(fw * full / 16) * 16) + 'px'; }
        const ci = (f) => Math.max(0, Math.min(6, Math.floor(f * 7)));
        const cs = ci(sF), cb = ci((() => { let el = this.e.cap2; el = el && (el.firstElementChild || el); if (!el) return 0; return (H - topOf(el)) / H; })());
        const st = {};
        if (cs !== this.s.cycS) st.cycS = cs;
        if (cb !== this.s.cyc) { st.cyc = cb; if (story === 2) ['chip0', 'chip1', 'chip2'].forEach((k, i) => this.e[k] && this.e[k].animate([{ transform: 'scale(.85)', opacity: .4 }, { transform: 'scale(1.08)', opacity: 1, offset: .6 }, { transform: 'scale(1)', opacity: 1 }], { duration: 380, delay: i * 60, easing: 'ease-out' })); }
        if (story !== this.s.story && this.s.view === 'home') st.story = story;
        const scrolled = y > H * 0.6; if (scrolled !== this.s.scrolled) st.scrolled = scrolled;
        if (Object.keys(st).length) this.set(st);
      });
    };

    storyChanged(o, n) {
      const R = ['-1.5deg', '1.5deg', '-1deg'], det = [this.e.det0, this.e.det1, this.e.det2];
      const out = o >= 0 && o < 3 && det[o], inn = n >= 0 && n < 3 && det[n];
      if (out && n === 3) { out.getAnimations().forEach(a => a.cancel()); out.animate([{ opacity: 1, transform: 'translateY(0) scale(1) rotate(' + R[o] + ')' }, { opacity: 0, transform: 'translateY(-4%) scale(.92) rotate(' + R[o] + ')' }], { duration: 300, easing: 'ease-in', fill: 'forwards' }); }
      else if (out) { out.getAnimations().forEach(a => a.cancel()); out.animate([{ opacity: 1, transform: 'translateY(0) scale(1) rotate(' + R[o] + ')' }, { opacity: 0, transform: 'translateY(-140%) scale(.35) rotate(8deg)' }], { duration: 320, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' }); }
      if (inn) { inn.getAnimations().forEach(a => a.cancel()); inn.animate([{ opacity: 0, transform: 'translateY(-140%) scale(.3) rotate(-14deg)' }, { opacity: 1, transform: 'translateY(-55%) scale(.7) rotate(-9deg)', offset: .25 }, { opacity: 1, transform: 'translateY(9%) scale(1.06) rotate(4deg)', offset: .62 }, { opacity: 1, transform: 'translateY(-3%) scale(.98) rotate(-1deg)', offset: .82 }, { opacity: 1, transform: 'translateY(0) scale(1) rotate(' + R[n] + ')' }], { duration: 900, delay: out ? 170 : 0, easing: 'cubic-bezier(.25,.8,.35,1)', fill: 'both' }); }
      const im = this.e.puffImg;
      if (im) { this._puffA && this._puffA.cancel(); if (n === 0) this._puffA = im.animate([{ transform: 'translateZ(0px) scale(1)', boxShadow: '0 0 0 rgba(13,23,52,0)' }, { transform: 'translateZ(70px) scale(1.07)', boxShadow: '0 34px 46px rgba(13,23,52,.42)', offset: .6 }, { transform: 'translateZ(44px) scale(1.03)', boxShadow: '0 22px 36px rgba(13,23,52,.32)' }], { duration: 950, delay: 850, easing: 'cubic-bezier(.3,1.3,.5,1)', fill: 'both' }); }
      if (n === 2) ['chip0', 'chip1', 'chip2'].forEach((k, i) => this.e[k] && this.e[k].animate([{ opacity: 0, transform: 'translateY(14px) scale(.6)' }, { opacity: 1, transform: 'translateY(-3px) scale(1.08)', offset: .7 }, { opacity: 1, transform: 'none' }], { duration: 520, delay: 250 + i * 140, easing: 'cubic-bezier(.3,1.4,.5,1)', fill: 'backwards' }));
    }

    anims() {
      const run = (el, kf, o) => el && el.animate(kf, o);
      run(this.e.pulse, [{ transform: 'scale(.6)', opacity: 0.9 }, { transform: 'scale(2.6)', opacity: 0 }], { duration: 1700, iterations: Infinity, easing: 'cubic-bezier(.2,.6,.4,1)' });
      run(this.e.orbit, [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], { duration: 16000, iterations: Infinity });
      const qf = []; AURAS.forEach((x, i) => { qf.push({ background: x.hex, offset: i / 7 }); qf.push({ background: x.hex, offset: (i + 0.8) / 7 }); }); qf.push({ background: AURAS[0].hex, offset: 1 });
      run(this.e.orbitQ, qf, { duration: 8400, iterations: Infinity });
      run(this.e.stitchLine, [{ strokeDashoffset: 0 }, { strokeDashoffset: -32 }], { duration: 1000, iterations: Infinity });
      run(this.e.stitchRect, [{ strokeDashoffset: 0 }, { strokeDashoffset: -32 }], { duration: 1000, iterations: Infinity });
      run(this.e.puffTitle, [{ textShadow: '0px 0px 0 #ffffff, 0px 0px 0 #ffffff, 0px 0px 0 #10ADE6, 0px 0px 0 #0D1734', transform: 'scale(1)' }, { textShadow: '1px 1px 0 #ffffff, 2px 2px 0 #ffffff, 3px 3px 0 #10ADE6, 4px 5px 0 #0D1734', transform: 'scale(1.05)' }], { duration: 1400, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
      if (this.e.swipeBob && !reduceMotion()) this.e.swipeBob.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-5px)' }, { transform: 'translateY(0)' }], { duration: 1600, iterations: Infinity, easing: 'ease-in-out' });
      this.startIdle();
    }

    /* ---------- 3D PUFF detail card ---------- */
    startIdle() { const t = this.e.tilt; if (!t || reduceMotion()) return; this._idle = t.animate([{ transform: 'rotateX(9deg) rotateY(-13deg)' }, { transform: 'rotateX(-6deg) rotateY(13deg)' }], { duration: 4200, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' }); }
    tilt(e) {
      const r = e.currentTarget.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5, t = this.e.tilt, sh = this.e.shine;
      if (this._idle) { this._idle.cancel(); this._idle = null; }
      if (t) t.style.transform = 'rotateX(' + (-y * 26).toFixed(2) + 'deg) rotateY(' + (x * 30).toFixed(2) + 'deg)';
      if (sh) sh.style.background = 'radial-gradient(circle at ' + ((x + 0.5) * 100).toFixed(1) + '% ' + ((y + 0.5) * 100).toFixed(1) + '%, rgba(255,255,255,.75), rgba(255,255,255,0) 50%)';
    }
    untilt() { const t = this.e.tilt; if (t) t.style.transform = ''; clearTimeout(this._it); this._it = setTimeout(() => { if (!this._idle) this.startIdle(); }, 250); }
    puffTap() {
      const im = this.e.puffImg, ti = this.e.puffTitle;
      if (im) im.animate([{ transform: 'translateZ(44px) scale(1.03)' }, { transform: 'translateZ(0px) scale(.97)', offset: .25 }, { transform: 'translateZ(95px) scale(1.12)', offset: .6 }, { transform: 'translateZ(44px) scale(1.03)' }], { duration: 750, easing: 'cubic-bezier(.3,1.2,.5,1)' });
      if (ti) ti.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)', offset: .5 }, { transform: 'scale(1)' }], { duration: 500, easing: 'cubic-bezier(.3,1.6,.5,1)', composite: 'add' });
    }

    /* ---------- navigation ---------- */
    route(a, push) {
      if (!this.cfg.productUrl || !window.history) return;
      const url = a == null ? (this.cfg.homeUrl || '/') : this.cfg.productUrl + '?aura=' + AURAS[a].id;
      if (location.pathname + location.search === url) return;
      try { history[push ? 'pushState' : 'replaceState']({ puff: true }, '', url); } catch (e) {}
    }
    fromLocation() {
      const pp = this.cfg.productUrl;
      if (pp && location.pathname === pp) {
        const q = new URLSearchParams(location.search).get('aura'), i = AURAS.findIndex(x => x.id === q);
        if (this.s.view !== 'product') this.openProduct(i < 0 ? SKY : i, true);
        else if (i >= 0 && i !== this.s.aura) this.pickAura(i, true);
      } else if (this.s.view === 'product') this.goHome(true);
    }
    startView() {
      if (this.cfg.startView === 'info') { const h = (location.hash.match(/^#info-([a-z]+)/) || [])[1]; if (h) setTimeout(() => this.openInfo(h), 60); return; }
    }
    /* Product pages open straight on the product view, at the aura in ?aura= or ?variant=. */
    initialView() {
      if (this.cfg.startView !== 'product') return;
      const p = new URLSearchParams(location.search), q = p.get('aura');
      let i = AURAS.findIndex(x => x.id === q);
      if (i < 0 && p.get('variant') && this.product) { const v = this.product.variants.find(x => String(x.id) === p.get('variant')); i = this.auraOfVariant(v); if (v && this.sizeOpt >= 0) this.s.size = v.options[this.sizeOpt]; }
      Object.assign(this.s, { view: 'product', aura: i < 0 ? SKY : i, stop: 0, dir: 1 });
    }
    openProduct(a, noRoute) {
      if (this.s.view === 'product') return;
      a = typeof a === 'number' ? a : SKY; this.lastNav = performance.now();
      const st = a === SKY ? Math.min(this.stageStop(), stopsFor(a).length - 1) : 0;
      // The model lives at the top of the story, so jump there (e.g. from the footer's Aura Collection link).
      // Repeat the jump: iPad/iPhone Safari ignores it while a swipe is still gliding.
      const sc = this.e.scroll;
      if (sc && sc.scrollTop > 0) {
        const top = () => { if (this.s.view === 'product' && sc.scrollTop !== 0) { sc.scrollTop = 0; this.onScroll(); } };
        sc.scrollTop = 0; this.onScroll();
        requestAnimationFrame(top); [80, 250, 600].forEach(ms => setTimeout(top, ms));
      }
      this.set({ view: 'product', aura: a, stop: st, dir: 1, menu: false, needSize: false, bagOpen: false, story: -1 });
      if (!noRoute) this.route(a, true);
      clearTimeout(this._slotT);
      this.root.focus({ preventScroll: true });
    }
    goHome(noRoute) {
      if (this.s.view !== 'product') return;
      this.set({ view: 'home', aura: SKY, stop: 0, dir: -1 });
      if (!noRoute) this.route(null, true);
      this.e.scroll && this.e.scroll.scrollTo({ top: 0, behavior: 'smooth' });
    }
    turn(d) { const s = this.s, n = stopsFor(s.aura).length; if (n < 2 || this.locked(380)) return; this.set({ stop: (s.stop + d + n) % n, dir: d }); }
    shift(d) { if (this.locked(420)) return; const s = this.s, a = (s.aura + d + 7) % 7; this.set({ aura: a, stop: Math.min(s.stop, stopsFor(a).length - 1), dir: d }); this.route(a); }
    pickAura(i, noRoute) { const s = this.s; if (i === s.aura || this.locked(300)) return; this.set({ aura: i, stop: Math.min(s.stop, stopsFor(i).length - 1), dir: i > s.aura ? 1 : -1 }); if (!noRoute) this.route(i); }
    menuBtn() {
      if (this.cfg.startView === 'info') { location.href = this.cfg.homeUrl || '/'; return; }
      if (this.s.info) this.set({ info: false }); else if (this.s.view === 'product') this.goHome(); else this.set({ menu: !this.s.menu, bagOpen: false });
    }
    scrollToSel(sel) {
      const sc = this.e.scroll, el = sc && sc.querySelector(sel); if (!el) return;
      const top = el.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - (this.desk ? 130 : 150);
      sc.scrollTo({ top: Math.min(top, sc.scrollHeight - sc.clientHeight), behavior: 'smooth' });
    }
    navTo(sel) {
      if (!this.e.scroll) { location.href = (this.cfg.homeUrl || '/') + sel; return; }
      const was = this.s.view === 'product';
      this.set({ menu: false, bagOpen: false, info: false }); if (was) this.goHome();
      setTimeout(() => this.scrollToSel(sel), was ? 450 : 60);
    }
    navShop() {
      if (!this.e.scroll) { location.href = this.cfg.productUrl || '/'; return; }
      this.set({ menu: false, bagOpen: false, info: false });
      if (this.s.view === 'product') { this.set({ aura: 0, stop: 0 }); this.route(0); } else this.openProduct(0);
    }
    openInfo(id) {
      const sc = this.e.infoScroll;
      if (!this.e.info) { location.href = (this.cfg.infoUrl || '/pages/info') + '#info-' + id; return; }
      const was = this.s.info || this.cfg.startView === 'info';
      this.set({ menu: false, bagOpen: false, info: true });
      setTimeout(() => {
        const el = sc && sc.querySelector('#info-' + id); if (!el) return;
        const head = this.e.info.querySelector('.puff-info__head'), hd = head ? head.getBoundingClientRect().bottom - sc.getBoundingClientRect().top : 0;
        const top = id === 'about' ? 0 : el.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - hd - 8;
        sc.scrollTo({ top, behavior: was ? 'smooth' : 'auto' });
      }, was ? 0 : 40);
    }
    bookGo(d) { const el = this.e.book; if (!el) return; const pg = Math.max(0, Math.min(2, this.s.book + d)); el.scrollTo({ left: pg * el.clientWidth, behavior: 'smooth' }); }
    onKey(e) {
      const k = e.key, s = this.s;
      if (s.slot && k === 'Escape') { this.closeSlot(); return; }
      if (s.info && k === 'Escape') { this.set({ info: false }); return; }
      if (s.bagOpen && k === 'Escape') { this.set({ bagOpen: false }); return; }
      if (s.view !== 'product') { if (s.menu && k === 'Escape') this.set({ menu: false }); return; }
      if (/^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '')) return;
      if (k === 'ArrowRight') this.turn(1); else if (k === 'ArrowLeft') this.turn(-1); else if (k === 'ArrowDown') this.shift(-1); else if (k === 'ArrowUp') this.shift(1); else if (k === 'Escape') this.goHome(); else return;
      e.preventDefault();
    }

    /* ---------- cart ---------- */
    shake() {
      const el = this.desk ? this.e.sizeBox : this.e.slim;
      el && el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(0)' }], { duration: 380 });
    }
    toast(msg) {
      const t = this.e.toast; if (!t) return;
      t.textContent = msg; t.classList.add('is-on');
      clearTimeout(this._tt); this._tt = setTimeout(() => t.classList.remove('is-on'), 2400);
    }
    async addToBag() {
      const s = this.s;
      if (!s.size) { this.set({ needSize: true }); this.shake(); return; }
      const aIdx = s.view === 'product' ? s.aura : SKY, a = AURAS[aIdx];
      if (!this.product) { this.toast('The Aura Tee product isn\'t connected yet'); return; }
      const v = this.variantFor(aIdx, s.size);
      if (!v || !v.available) { this.toast('Sold out: ' + a.name + ', ' + s.size); this.shake(); return; }
      const btns = Array.from(this.root.querySelectorAll('[data-action="addToBag"]'));
      btns.forEach(b => { b.disabled = true; });
      try {
        const res = await fetch((this.cfg.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) { this.toast(body.description || body.message || 'Couldn\'t add that, try again'); return; }
        this.toast('Added to bag: Aura Tee, ' + a.name + ', ' + s.size);
        await this.loadCart();
        this.$$('badge').forEach(b => b.animate([{ transform: 'scale(.4)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 480, easing: 'cubic-bezier(.3,1.6,.5,1)' }));
      } catch (e) { this.toast('Couldn\'t add that, try again'); }
      finally { btns.forEach(b => { b.disabled = false; }); }
    }
    async loadCart() {
      try {
        const res = await fetch((this.cfg.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        this.cart = await res.json(); this.renderBag(); this.render();
      } catch (e) {}
    }
    async changeLine(key, quantity) {
      try {
        const res = await fetch((this.cfg.cartChangeUrl || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        if (res.ok) { this.cart = await res.json(); this.renderBag(); this.render(); }
      } catch (e) {}
    }
    renderBag() {
      const c = this.cart, full = c.item_count > 0, esc = (x) => String(x).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
      this.$$('badge').forEach(b => { b.textContent = String(c.item_count); });
      if (this.e.bagTitle) this.e.bagTitle.textContent = full ? 'Your bag' : 'Your bag is empty';
      if (this.e.bagEmpty) this.e.bagEmpty.hidden = full;
      if (this.e.bagFoot) this.e.bagFoot.hidden = !full;
      if (this.e.bagItems) this.e.bagItems.innerHTML = c.items.map(it => {
        let hex = '', ai = -1;
        if (this.product && it.product_id === this.product.id) ai = this.auraOfVariant(this.product.variants.find(v => v.id === it.variant_id));
        if (ai < 0 && it.options_with_values) { const o = it.options_with_values.find(x => /aura|colou?r/i.test(x.name)); if (o) ai = AURAS.findIndex(a => norm(a.name) === norm(o.value)); }
        if (ai >= 0) hex = 'background:' + AURAS[ai].hex + ';'; else if (it.image) hex = 'background-image:url(' + esc(it.image) + ');';
        const meta = (it.variant_title ? it.variant_title.replace(/ \/ /g, ' · ') + ' · ' : '') + 'Qty ' + it.quantity;
        return '<div class="puff-bag__item"><span class="puff-bag__dot" style="' + hex + '"></span><div class="puff-bag__info"><div class="puff-bag__name">' + esc(it.product_title) + '</div><div class="puff-bag__meta">' + esc(meta) + '</div></div><div class="puff-bag__price">' + esc(formatMoney(it.final_line_price, this.money)) + '</div><button class="puff-bag__rm" type="button" data-rm="' + esc(it.key) + '" aria-label="Remove">Remove</button></div>';
      }).join('');
      if (this.e.bagItems && !this.e.bagItems._b) { this.e.bagItems._b = true; this.e.bagItems.addEventListener('click', (e) => { const b = e.target.closest('[data-rm]'); if (b) this.changeLine(b.dataset.rm, 0); }); }
      const th = this.cfg.freeShipping || 10000, tot = c.total_price || 0;
      if (this.e.shipMeter) this.e.shipMeter.style.width = Math.min(100, tot / th * 100) + '%';
      if (this.e.shipNote) this.e.shipNote.textContent = tot >= th ? 'Free UK delivery unlocked' : formatMoney(th - tot, this.money) + ' away from free UK delivery';
      if (this.e.subtotal) this.e.subtotal.textContent = formatMoney(tot, this.money);
    }

    /* ---------- timers and popup ---------- */
    startTimers() {
      setInterval(() => { if (!this.s.scrolled && this.s.view === 'home' && !document.hidden) this.set({ awC: (this.s.awC + 1) % 7 }); }, 1400);
      const pc = this.cfg.popup || {}, mode = pc.mode || 'once';
      if (!this.e.slotBack || mode === 'off' || pc.suppress || this.cfg.startView !== 'home') return;
      let seen = false; try { seen = localStorage.getItem('puff-slot-seen') === '1'; } catch (e) {}
      if (mode === 'once' && seen) return;
      this._slotT = setTimeout(() => { if (this.s.view === 'home' && !this.s.info && !this.s.menu) this.openSlot(); }, +(pc.delay == null ? 3500 : pc.delay));
    }
    openSlot() { this.s.slot = true; this.e.slotBack.hidden = false; this.slotZoom(); const p = this.e.slot; p && p.start && p.start(); }
    closeSlot() {
      try { localStorage.setItem('puff-slot-seen', '1'); } catch (e) {}
      this.s.slot = false; if (this.e.slotBack) this.e.slotBack.hidden = true;
      this.root.focus({ preventScroll: true });
    }
    slotZoom() { const z = this.e.slotZoom; if (!z) return; z.style.zoom = this.desk ? '1' : String(Math.min(1, ((this.root.clientWidth || 390) - 24) / 426)); }
  }

  function boot() {
    document.querySelectorAll('[data-puff-root]').forEach(root => {
      if (root._puff) return;
      const sec = root.closest('.shopify-section') || document, cfgEl = sec.querySelector('[data-puff-config]');
      let cfg = {}; try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}
      root._puff = new PuffSite(root, cfg);
    });
  }
  window.PuffSite = PuffSite;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
